import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LocalStorageService } from '@app/services/local-storage.service';
import { NavigationService } from '@app/services/navigation.service';
import { PetService } from '@app/services/pet.service';
import { UserAccountService } from '@app/services/user-account.service';
import { PetListComponent as NewPetListComponent } from '../../../../app/components/booking-steps/pet-list/pet-list.component';
import { AddPetComponent } from '../add-pet/add-pet.component';

@Component({
    selector: 'app-pet-list',
    templateUrl: './pet-list.component.html',
    styleUrls: ['./pet-list.component.scss'],
    standalone: false,
})
export class PetListComponent extends NewPetListComponent {
    constructor(
        private _localStorageService: LocalStorageService,
        private _petService: PetService,
        private _navigationService: NavigationService,
        private _fb: FormBuilder,
        private _userAccountService: UserAccountService,
        private bottomSheet: MatBottomSheet
    ) {
        super(_localStorageService, _petService, _navigationService, _fb, _userAccountService);
    }

    public addPet(): void {
        const ref = this.bottomSheet.open(AddPetComponent, { disableClose: true });

        const afterDismissed = (ref as unknown as { afterDismissed?: () => { subscribe: (fn: () => void) => void } }).afterDismissed;
        if (typeof afterDismissed === 'function') {
            afterDismissed.call(ref).subscribe(() => {
                this.refreshPetList();
            });
        }
    }
}
